export default {
  buttons: {
    send_code: 'Trimite codul de autentificare',
  },
  placeholders: {
    mobile_number: 'Număr de telefon',
    email: 'Adresă de email',
  },
  feedback: {
    phone_number_required: 'Te rugăm să introduci numărul de telefon',
    email_required: 'Te rugăm să introduci adresa de email',
  },
};
